module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('ScanBarcode', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    on: {
      "setBarcode": _vm.getBarcode
    }
  }), (_vm.reviewEmployee === undefined) ? _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h4', [_vm._v("覆核人員請刷條碼")])]) : _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h4', [_vm._v("覆核人員")]), _c('h4', [_c('strong', [_vm._v(_vm._s(_vm.reviewEmployee.last_name) + _vm._s(_vm.reviewEmployee.first_name))])]), _c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.confirmRx
    }
  }, [_vm._v("確認覆核")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44d0883c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/RxCheckBarcode.vue
// module id = 1456
// module chunks = 1